import React from "react";
import { useEffect, useState } from "react";
import axios from '../../axios/axiosconf';
import { useHistory } from "react-router";
import { useLocation } from "react-router-dom";
import logo from '../../../resources/img/logo-2.png';
import { buildCuestionarioSearch, normalizarTipoDocumentoCuestionario, withCuestionarioToken } from './cuestionarioPacienteHelpers';

function normRh(val) {
    if (val === null || val === undefined) return '';
    return String(val).trim().toLowerCase();
}

function CuestionarioPaciente1() {

    const [estadoCheck, setEstadocheck] = useState(false);

    const queryParams = useLocation().search;
    const qs = new URLSearchParams(queryParams);
    const [idPaciente] = useState(qs.get('id'));
    const [tokenPaciente] = useState(qs.get('token'));

    const [primerNombre, setPrimerNombre] = useState('');
    const [segundoNombre, setSegundoNombre] = useState('');
    const [primerApellido, setPrimerApellido] = useState('');
    const [segundoApellido, setSegundoApellido] = useState('');

    const [numeroDocumento, setNumeroDocumento] = useState('');
    const [tipoDocumento, setTipoDocumento] = useState('CC');
    const [genero, setGenero] = useState('');
    const [identidadGenero, setIdentidadGenero] = useState('');
    const [tipoSangre, setTipoSangre] = useState('');

    const [logoClienteUrl, setLogoClienteUrl] = useState(null);

    const [errorlist, setErrorlist] = useState({});
    const [loading, setLoading] = useState(false);

    const history = useHistory();

    useEffect(() => {
        if (!idPaciente) return;

        const config = {
            params: {
                id: idPaciente,
                token: tokenPaciente || undefined,
            }
        };

        axios.get('/paciente-publico', config)
            .then(response => {
                const row = response.data[0];
                if (!row) return;
                setPrimerNombre(row.primer_nombre || '');
                setSegundoNombre(row.segundo_nombre || '');
                setPrimerApellido(row.primer_apellido || '');
                setSegundoApellido(row.segundo_apellido || '');
                setNumeroDocumento(row.numero_documento || '');
                setTipoDocumento(normalizarTipoDocumentoCuestionario(row.tipo_documento));
                setGenero(row.sexo || '');
                setIdentidadGenero(row.identidad_genero || '');
                setTipoSangre(normRh(row.rh));
                setLogoClienteUrl(row.logo_cliente_url || null);
            })
            .catch(error => {
                console.log(error);
            });
    }, [idPaciente, tokenPaciente]);

    const handleSubmit = (e) => {
        e.preventDefault();
        setLoading(true);

        const config = {
            id: idPaciente,
            primer_nombre: primerNombre,
            segundo_nombre: segundoNombre,
            primer_apellido: primerApellido,
            segundo_apellido: segundoApellido,
            numero_documento: numeroDocumento,
            tipo_documento: normalizarTipoDocumentoCuestionario(tipoDocumento),
            sexo: genero,
            identidad_genero: identidadGenero,
            rh: tipoSangre
        };

        axios.put('/datos-personales-publico', withCuestionarioToken(config, tokenPaciente))
            .then(() => {
                setLoading(false);
                history.push({
                    pathname: '/cuestionario-paciente2',
                    search: buildCuestionarioSearch(idPaciente, tokenPaciente)
                });
            })
            .catch(error => {
                console.log(error.response?.data);
                setLoading(false);
                setErrorlist(error.response?.data?.errors || {});
            });
    };

    function handleCheck() {
        setEstadocheck((v) => !v);
    }

    const req = <span className="text-danger"> *</span>;

    return (

        <div className="contenedor-cuestionario">

            <div style={{ textAlign: 'center' }}>
                <img
                    src={logoClienteUrl || logo}
                    alt={logoClienteUrl ? 'Logo clínica' : 'Smile software'}
                    style={{ maxWidth: 220, maxHeight: 88, objectFit: 'contain' }}
                    onError={(e) => {
                        e.currentTarget.onerror = null;
                        e.currentTarget.src = logo;
                        e.currentTarget.alt = 'Smile software';
                    }}
                />
            </div>

            <div className="row mb-2" style={{ marginTop: '30px' }}>
                <h1 className="m-0" style={{ textAlign: 'center', width: '100%' }}>Información personal</h1>
            </div>

            <div className="indicador-progreso">
                <div className="indicador-punto completado">1</div>
                <div className="indicador-linea"></div>
                <div className="indicador-punto">2</div>
                <div className="indicador-linea"></div>
                <div className="indicador-punto">3</div>
                <div className="indicador-linea"></div>
                <div className="indicador-punto">4</div>
            </div>

            <form id="quickForm" onSubmit={handleSubmit} autoComplete="off">

                <div className="card cuestionario-paciente">
                    <div className="card-header">
                        <h4 className="card-title w-100">
                            <span className="d-block w-100" style={{ textAlign: 'center' }}>
                                Datos Personales
                            </span>
                        </h4>
                    </div>
                    <div id="infobasica" className="collapse show">
                        <div className="card-body">

                            <div className="row">
                                <div className="col-md-3">
                                    <div className="form-group">
                                        <label htmlFor="primerNombre">Primer nombre{req}</label>
                                        <input type="text" className="form-control" id="primerNombre" value={primerNombre} onChange={(e) => setPrimerNombre(e.target.value)} />
                                        <div className="invalid-feedback visible">
                                            {errorlist.primer_nombre}
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-3">
                                    <div className="form-group">
                                        <label htmlFor="segundoNombre">Segundo nombre</label>
                                        <input type="text" className="form-control" id="segundoNombre" value={segundoNombre} onChange={(e) => setSegundoNombre(e.target.value)} />
                                    </div>
                                </div>
                                <div className="col-md-3">
                                    <div className="form-group">
                                        <label htmlFor="primerApellido">Primer apellido{req}</label>
                                        <input type="text" className="form-control" id="primerApellido" value={primerApellido} onChange={(e) => setPrimerApellido(e.target.value)} />
                                        <div className="invalid-feedback visible">
                                            {errorlist.primer_apellido}
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-3">
                                    <div className="form-group">
                                        <label htmlFor="segundoApellido">Segundo apellido</label>
                                        <input type="text" className="form-control" id="segundoApellido" value={segundoApellido} onChange={(e) => setSegundoApellido(e.target.value)} />
                                    </div>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-md-3">
                                    <div className="form-group">
                                        <label htmlFor="numeroDocumento">Número de documento{req}</label>
                                        <input type="text" className="form-control" id="numeroDocumento" value={numeroDocumento} onChange={(e) => setNumeroDocumento(e.target.value)} />
                                        <div className="invalid-feedback visible">
                                            {errorlist.numero_documento}
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-3">
                                    <div className="form-group">
                                        <label htmlFor="tipoDoc">Tipo documento{req}</label>
                                        <select className="form-control" id="tipoDoc" value={tipoDocumento} onChange={(e) => setTipoDocumento(e.target.value)}>
                                            <option value="CC">CC - CEDULA DE CIUDADANIA</option>
                                            <option value="CE">CE - CEDULA DE EXTRANJERIA</option>
                                            <option value="CD">CD - CARNET DIPLOMATICO</option>
                                            <option value="CN">CN - CERTIFICADO DE NACIDO VIVO</option>
                                            <option value="DE">DE - DOCUMENTOS EXTRANJERO</option>
                                            <option value="MS">MS - MENOR SIN IDENTIFICAR</option>
                                            <option value="NIP">NIP - NUMERO DE IDENTIFICACION PERSONAL</option>
                                            <option value="NIT">NIT - NUMERO DE IDENTIFICACION TRIBUTARIA</option>
                                            <option value="PA">PA - PASAPORTE</option>
                                            <option value="PT">PT - PERMISO TEMPORAL DE PERMANENCIA</option>
                                            <option value="PE">PE - PERMISO ESPECIAL DE PERMANENCIA</option>
                                            <option value="RC">RC - REGISTRO CIVIL</option>
                                            <option value="TI">TI - TARJETA DE IDENTIDAD</option>
                                            <option value="SC">SC - SALVOCONDUCTO DE PERMANENCIA</option>
                                            <option value="SI">SI - SIN IDENTIFICACION</option>
                                            <option value="AS">AS - ADULTO SIN IDENTIFICAR</option>
                                        </select>
                                        <div className="invalid-feedback visible">
                                            {errorlist.tipo_documento}
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-3">
                                    <div className="form-group">
                                        <label htmlFor="genero">Sexo biológico{req}</label>
                                        <select className="form-control" id="genero" value={genero} onChange={(e) => setGenero(e.target.value)}>
                                            <option value=""></option>
                                            <option value="01">HOMBRE</option>
                                            <option value="02">MUJER</option>
                                            <option value="03">INDETERMINADO/INTERSEXUAL</option>
                                        </select>
                                        <div className="invalid-feedback visible">
                                            {errorlist.sexo}
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-3">
                                    <div className="form-group">
                                        <label htmlFor="identidad">Identidad de género{req}</label>
                                        <select className="form-control" id="identidad" value={identidadGenero} onChange={(e) => setIdentidadGenero(e.target.value)}>
                                            <option value=""></option>
                                            <option value="01">MASCULINO</option>
                                            <option value="02">FEMENINO</option>
                                            <option value="03">TRANSGÉNERO</option>
                                            <option value="04">NEUTRO</option>
                                            <option value="05">NO LO DECLARA</option>
                                        </select>
                                        <div className="invalid-feedback visible">
                                            {errorlist.identidad_genero}
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-3">
                                    <div className="form-group">
                                        <label htmlFor="tipoSangre">Tipo de sangre{req}</label>
                                        <select className="form-control" id="tipoSangre" value={tipoSangre} onChange={(e) => setTipoSangre(e.target.value)}>
                                            <option value=""></option>
                                            <option value="a+">A+</option>
                                            <option value="a-">A-</option>
                                            <option value="b+">B+</option>
                                            <option value="b-">B-</option>
                                            <option value="ab+">AB+</option>
                                            <option value="ab-">AB-</option>
                                            <option value="o+">O+</option>
                                            <option value="o-">O-</option>
                                        </select>
                                        <div className="invalid-feedback visible">
                                            {errorlist.rh}
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-md-12" style={{ textAlign: 'center' }}>
                                    <input type="checkbox" name="acepto-politica" id="acepto-politica" onChange={() => handleCheck()} />
                                    <label htmlFor="acepto-politica">&nbsp;Acepto la <a href="http://www.brand-works.co/smile/politica-tratamiento-datos-personales.pdf" target="_blank" rel="noopener noreferrer">política de tratamiento de datos personales</a></label>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>

                <div className="row">
                    <button type="submit" className="btn btn-primary" style={{ margin: '0 auto', fontSize: '1.4rem' }} disabled={!estadoCheck}>
                        Continuar&nbsp;
                        {loading ? (<span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>) : null}
                    </button>
                </div>
            </form>
        </div>

    );
}
export default CuestionarioPaciente1;
